import { env } from '@/env';

/**
 * Gli scacchi su Limulo (E6 di ADR-0193, `accepted`; Luca, a qchess-orcb 06/10: «voglio adesso poter selezionare e usare
 * qchess in tma e next (staging)»): la sezione NUOVA — scacchiera `@qlash-it/qchess-board-ui`, tornei, partite e Live dal
 * BFF Limulo — acceso SOLO col flag suo (`VITE_FEATURE_CHESS_LIMULO_ENABLED`) in AND con Limulo: il gioco passa dal BFF
 * (`/v1/games/chess/*`) e dai tornei di qTournaments, mai dal vecchio `qchess-api`.
 * 🔴 UN predicato: lo leggono il selettore dei giochi (`useGameSelection`), le schede della Hub e la rotta del tavolo
 * (`chess/match/:id`, P4a). Due copie divergerebbero, e il selettore offrirebbe un gioco senza rotte. Il ruolo `beta` non si ricontrolla qui: lo
 * chiedono le rotte e la Hub, come per il backgammon (`RoleGate`, `showQgammon`).
 * ⛔ Il `/chess` di produzione (Lichess, `qchess.qlash.gg`, `featureChessEnabled`) NON si tocca: il suo ritiro e' un GO di Luca a
 * parte (ADR-0193 §3.10). Le rotte nuove stanno sotto percorsi che il vecchio non ha (`chess/match|live|replay/:id`), quindi i
 * due insiemi possono coesistere e nessuno dei due flag spegne l'altro. Con questo flag spento — oggi in OGNI file env,
 * `.env.staging` compreso — la build si comporta come prima di questo file.
 */
export function chessLimuloAcceso(): boolean {
  return env.featureChessLimuloEnabled && env.featureLimuloEnabled;
}
